export default function handleSubGrupoName(subGrupoName) {
  let split = subGrupoName?.split("_");
  if (split?.length > 0) {
    return split.join(" ");
  }
}
